// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Caml_array from "../../../../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Caml_format from "../../../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_option from "../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as ReactModal from "react-modal";
import * as CountryContext from "../../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CrmRepoManager from "../../../../../../to-be-migrated/domain/repo/CrmRepoManager.bs.js";
import * as Button$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as FormInput$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as ModalFooter$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/modal/ModalFooter.bs.js";
import * as ModalStyles$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/modal/ModalStyles.bs.js";
import * as FormTitleBar$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormTitleBar.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as SelectComponent$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/drop-downs/SelectComponent.bs.js";
import * as SuspensionSelectReasonCmp from "../../../vm-mapper/driver-records/SuspensionSelectReasonCmp.bs.js";
import * as PrimitiveFormTypes$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/PrimitiveFormTypes.bs.js";
import * as SuspensionTimeRangeSelection from "../../../vm-mapper/driver-records/SuspensionTimeRangeSelection.bs.js";
import * as LoadingViewComponent$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/LoadingViewComponent.bs.js";
import * as SuccessInfoComponent$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/success/SuccessInfoComponent.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

var validators_hours = {
  strategy: /* OnSubmit */4,
  validate: (function (input) {
      var hours = input.hours;
      if (hours !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: hours
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_comment = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      return PrimitiveFormTypes$Catalyst.getValue({
                  TAG: /* String */1,
                  _0: param.comment
                });
    })
};

var validators_reason = {
  strategy: /* OnSubmit */4,
  validate: (function (input) {
      var reason = input.reason;
      if (reason !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: reason.value
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Please select a valid suspension reason and try again"
              };
      }
    })
};

var validators = {
  hours: validators_hours,
  comment: validators_comment,
  reason: validators_reason
};

function initialFieldsStatuses(_input) {
  return {
          hours: /* Pristine */0,
          comment: /* Pristine */0,
          reason: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            hours: /* Pristine */0,
            comment: /* Pristine */0,
            reason: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.hours;
  var match_0 = match ? match._0 : Curry._1(validators.hours.validate, input);
  var match$1 = fieldsStatuses.comment;
  var match_0$1 = match$1 ? match$1._0 : Curry._1(validators.comment.validate, input);
  var match$2 = fieldsStatuses.reason;
  var match_0$2 = match$2 ? match$2._0 : Curry._1(validators.reason.validate, input);
  var hoursResult = match_0;
  var hoursResult$1;
  if (hoursResult.TAG === /* Ok */0) {
    var commentResult = match_0$1;
    if (commentResult.TAG === /* Ok */0) {
      var reasonResult = match_0$2;
      if (reasonResult.TAG === /* Ok */0) {
        return {
                TAG: /* Valid */0,
                output: {
                  reason: reasonResult._0,
                  comment: commentResult._0,
                  hours: hoursResult._0
                },
                fieldsStatuses: {
                  hours: /* Dirty */{
                    _0: hoursResult,
                    _1: /* Shown */0
                  },
                  comment: /* Dirty */{
                    _0: commentResult,
                    _1: /* Shown */0
                  },
                  reason: /* Dirty */{
                    _0: reasonResult,
                    _1: /* Shown */0
                  }
                },
                collectionsStatuses: undefined
              };
      }
      hoursResult$1 = hoursResult;
    } else {
      hoursResult$1 = hoursResult;
    }
  } else {
    hoursResult$1 = hoursResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            hours: /* Dirty */{
              _0: hoursResult$1,
              _1: /* Shown */0
            },
            comment: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            reason: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurHoursField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.hours, validators_hours, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  hours: status,
                                  comment: init.comment,
                                  reason: init.reason
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurCommentField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.comment, validators_comment, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  hours: init.hours,
                                  comment: status,
                                  reason: init.reason
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurReasonField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.reason, validators_reason, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  hours: init.hours,
                                  comment: init.comment,
                                  reason: status
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */3 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */3,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */4,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */6);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */5);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */4 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */5 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */6 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateHoursField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.hours, state.submissionStatus, validators_hours, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            hours: status,
                                            comment: init.comment,
                                            reason: init.reason
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateCommentField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.comment, state.submissionStatus, validators_comment, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            hours: init.hours,
                                            comment: status,
                                            reason: init.reason
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateReasonField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, state.fieldsStatuses.reason, state.submissionStatus, validators_reason, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            hours: init.hours,
                                            comment: init.comment,
                                            reason: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */3 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                hours: /* Pristine */0,
                                comment: /* Pristine */0,
                                reason: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                hours: /* Pristine */0,
                                comment: /* Pristine */0,
                                reason: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */4 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */5 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateHours: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateHoursField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateComment: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateCommentField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateReason: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateReasonField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurHours: (function (param) {
              return Curry._1(dispatch, /* BlurHoursField */0);
            }),
          blurComment: (function (param) {
              return Curry._1(dispatch, /* BlurCommentField */1);
            }),
          blurReason: (function (param) {
              return Curry._1(dispatch, /* BlurReasonField */2);
            }),
          hoursResult: Formality.exposeFieldResult(state.fieldsStatuses.hours),
          commentResult: Formality.exposeFieldResult(state.fieldsStatuses.comment),
          reasonResult: Formality.exposeFieldResult(state.fieldsStatuses.reason),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.hours || match.comment || match.reason) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */3);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */4);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */5);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */5,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */6);
            })
        };
}

var SuspensionForm = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function getSuspensionReason(suspensionReasonsList) {
  return List.map((function (reason) {
                return {
                        key: String(reason.id),
                        value: String(reason.id),
                        text: reason.description
                      };
              }), suspensionReasonsList);
}

function getErrorSection(error) {
  if (error !== undefined) {
    return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                error: error
              });
  } else {
    return null;
  }
}

function SuspensionModal(Props) {
  var suspensionReasons = Props.suspensionReasons;
  var refreshView = Props.refreshView;
  var onToggle = Props.onToggle;
  var msisdn = Props.msisdn;
  var openSnackbar = Props.openSnackbar;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var suspensionOptions = getSuspensionReason(suspensionReasons);
  var match$1 = React.useState(function () {
        
      });
  var setSelectedHourIndex = match$1[1];
  var match$2 = React.useState(function () {
        return -1;
      });
  var setSelectedReasonId = match$2[1];
  var selectedReasonId = match$2[0];
  var match$3 = React.useReducer((function (_state, action) {
          if (action.TAG === /* OnSuccess */0) {
            var data = action._0;
            Curry._1(openSnackbar, data.status === 200 ? ({
                      TAG: /* Success */0,
                      _0: data.message
                    }) : ({
                      TAG: /* Error */1,
                      _0: data.message
                    }));
            Curry._1(refreshView, undefined);
            Curry._1(onToggle, undefined);
            return {
                    requestStatus: {
                      TAG: /* Live */1,
                      _0: data
                    }
                  };
          }
          Curry._1(refreshView, undefined);
          Curry._1(onToggle, undefined);
          return {
                  requestStatus: {
                    TAG: /* Error */2,
                    _0: action._0
                  }
                };
        }), {
        requestStatus: /* Init */0
      });
  var dispatch = match$3[1];
  var form = useForm({
        reason: undefined,
        comment: "",
        hours: undefined
      }, (function (output, submissionCbs) {
          var RepoInstance = CrmRepoManager.getSuspensionRepo(undefined);
          return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                        var hours = output.hours;
                        return Curry._5(RepoInstance.suspendPartner, msisdn, output.reason, output.comment, hours !== undefined ? String(hours) : "", country);
                      }), (function (data) {
                        Curry._1(submissionCbs.notifyOnSuccess, undefined);
                        return Curry._1(dispatch, {
                                    TAG: /* OnSuccess */0,
                                    _0: data
                                  });
                      }), (function (error) {
                        return Curry._1(dispatch, {
                                    TAG: /* OnError */1,
                                    _0: error
                                  });
                      }));
        }));
  var getFirstReasonDuration = function (index) {
    var array = $$Array.of_list(List.nth(List.filter(function (record) {
                    return record.id === index;
                  })(suspensionReasons), 0).suspension_durations);
    return Caml_array.get(array, 0);
  };
  var disableSubmit = function (param) {
    if (selectedReasonId > -1) {
      return form.input.comment.trim().length === 0;
    } else {
      return true;
    }
  };
  var _data = match$3[0].requestStatus;
  var tmp;
  if (typeof _data === "number") {
    tmp = React.createElement(React.Fragment, undefined, React.createElement("form", {
              className: "suspension-form",
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  
                })
            }, React.createElement("div", {
                  className: "suspension-form__section"
                }, React.createElement(SuspensionSelectReasonCmp.make, {
                      handleUpdate: (function ($$event) {
                          return Curry._2(form.updateReason, (function (input, value) {
                                        var index = value !== undefined ? Caml_format.caml_int_of_string(value.key) : -1;
                                        Curry._1(setSelectedReasonId, (function (param) {
                                                if (index > -1) {
                                                  Curry._2(form.updateHours, (function (input, value) {
                                                          Curry._1(setSelectedHourIndex, (function (param) {
                                                                  return 0;
                                                                }));
                                                          return {
                                                                  reason: input.reason,
                                                                  comment: input.comment,
                                                                  hours: value
                                                                };
                                                        }), getFirstReasonDuration(index).hours);
                                                  return index;
                                                } else {
                                                  return index;
                                                }
                                              }));
                                        return {
                                                reason: value,
                                                comment: input.comment,
                                                hours: input.hours
                                              };
                                      }), SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), suspensionOptions));
                        }),
                      suspensionOptions: suspensionOptions,
                      result: form.reasonResult,
                      value: form.input.reason
                    }), React.createElement(SuspensionTimeRangeSelection.make, {
                      selectedReasonId: selectedReasonId,
                      suspensionReasons: suspensionReasons,
                      handleUpdate: (function (_index, duration) {
                          return Curry._2(form.updateHours, (function (input, value) {
                                        Curry._1(setSelectedHourIndex, (function (param) {
                                                return _index;
                                              }));
                                        return {
                                                reason: input.reason,
                                                comment: input.comment,
                                                hours: value
                                              };
                                      }), duration.hours);
                        }),
                      selectedHourIndex: match$1[0]
                    }), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("Add comments here", (function ($$event) {
                              return Curry._2(form.updateComment, (function (input, value) {
                                            return {
                                                    reason: input.reason,
                                                    comment: value,
                                                    hours: input.hours
                                                  };
                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                            }), selectedReasonId < 0, undefined, undefined, undefined, undefined, undefined, form.commentResult, undefined, "max-width comment-input" + (
                            selectedReasonId < 0 ? " disable-comment" : ""
                          ), true, undefined, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: form.input.comment
                      }
                    })), React.createElement("div", {
                  className: "submit"
                }, React.createElement(Button$Catalyst.make, {
                      text: "Suspend",
                      cb: (function (param) {
                          return Curry._1(form.submit, undefined);
                        }),
                      className: "btn-primary submit-button",
                      disabled: disableSubmit(undefined)
                    }))));
  } else {
    switch (_data.TAG | 0) {
      case /* Loading */0 :
          tmp = React.createElement(LoadingViewComponent$Catalyst.make, {});
          break;
      case /* Live */1 :
          tmp = React.createElement(React.Fragment, undefined, React.createElement(SuccessInfoComponent$Catalyst.make, {
                    message: _data._0.message
                  }), React.createElement(ModalFooter$Catalyst.make, {
                    label: "Close",
                    cb: (function (param) {
                        Curry._1(refreshView, undefined);
                        return Curry._1(onToggle, undefined);
                      })
                  }));
          break;
      case /* Error */2 :
          tmp = React.createElement(React.Fragment, undefined, React.createElement(ErrorDisplayComponent$Catalyst.make, {
                    error: _data._0
                  }), React.createElement(ModalFooter$Catalyst.make, {
                    label: "Close",
                    cb: (function (param) {
                        Curry._1(refreshView, undefined);
                        return Curry._1(onToggle, undefined);
                      })
                  }));
          break;
      
    }
  }
  return React.createElement(ReactModal, {
              isOpen: true,
              onRequestClose: (function (param) {
                  return Curry._1(onToggle, undefined);
                }),
              style: ModalStyles$Catalyst.getAlignContentCenterStyle("50rem", undefined),
              className: "c-suspension-modal",
              ariaHideApp: false,
              shouldCloseOnOverlayClick: false,
              children: null
            }, React.createElement(FormTitleBar$Catalyst.make, {
                  title: "Suspend Driver",
                  onCloseCb: onToggle
                }), tmp);
}

var make = SuspensionModal;

export {
  SuspensionForm ,
  getSuspensionReason ,
  getErrorSection ,
  make ,
  
}
/* react Not a pure module */
